import React from 'react';


function WelcomeFlagShip() {
  return (
    <div className="text-container">
      <div className="welcome-body-wrapper">
        <div className="welcome-paragraph-wrapper">
          <h1>Book your Virtual Appointment with an AMSALE Stylist</h1>
          <p>
            Schedule a personalized virtual appointment with a stylist from our AMSALE Flagship in SoHo. Our dedicated
            stylists will guide you and/or your Bridal Party to discover the perfect AMSALE dress, no matter where you
            or your bridal party are located.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            Please fill out the request form, and a stylist will be in touch with you to schedule your 30-minute
            one-on-one video call.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <strong>
            <h2>
              Why is a virtual appointment perfect for you?
            </h2>
          </strong>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              Shopping for a Special Event
            </h3>
            Whether you are a bride, a member of the bridal party, or shopping for a special event, our virtual
            appointments provide a unique experience with expert advice. Meet with a dedicated stylist to determine the
            best color, fabric, and style for your event.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              For Brides and Bridal Party Members
            </h3>
            If you are unable to visit our NYC Flagship, we can bring your bridal party together with ease or help you
            discover the perfect AMSALE dress tailored to your vision.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              Streamlined Ordering Process
            </h3>
            If you already know what dress (color, fabric, and style) you’d like, you and your stylist can discuss
            measurements and place an order during your appointment.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomeFlagShip;
